export default "__VITE_ASSET__DGOdSpJX__"